import { isFmeaRiskList } from "@design-controls/types";
import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { useCurrentProduct } from "../useCurrentProduct";

export const useFMEARiskList = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  const { isLoading, data } = useQuery({
    queryFn: () => designControlsApi.query(companyId, productId),
    queryKey: ["OPEN_ISSUE_LIST", companyId, productId],
    select: (records) => records.filter(isFmeaRiskList),
  });

  return {
    isLoading,
    data,
  };
};
